import { render, staticRenderFns } from "./EcommerceStatistics.vue?vue&type=template&id=7442cc59&scoped=true&"
import script from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatistics.vue?vue&type=style&index=0&id=7442cc59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442cc59",
  null
  
)

export default component.exports